<template>
  <div v-if="showView" class="page-alert flex flex-center zindex-tip">
    <div class="page-body bg-white">
      <div class="page-header flex-row-align-center flex-row-justify-space-between">
        <p class="font-size-24 font-bold">专题</p>
        <img class="cursor" src="../../../../../assets/icon-lib-close-blue.png" alt="" @click="closeView">
      </div>
      <div class="page-options">
        <div class="page-options-region-topic flex-row-align-center flex-row-justify-space-between">
          <div class="page-options-selection flex-row-align-center">
            <div class="mach-height position-relative flex-center cursor" data-sel="0" @click="topicMenuSelect">
              <p class="font-color-264480 font-size-14">最新</p>
              <p v-if="topicTopSelIndex==0" class="position-absolute line bg-282B80" />
            </div>
            <div class="mach-height position-relative flex-center cursor" data-sel="1" @click="topicMenuSelect">
              <p class="font-color-264480 font-size-14">热门</p>
              <p v-if="topicTopSelIndex==1" class="position-absolute line bg-282B80" />
            </div>
          </div>
          <div class="flex-row-align-center">
            <p class="font-size-12 font-color-999 space">显示{{ total }}中的{{ range.start }}-{{ range.end }}条</p>
            <p class="font-size-12 font-color-264480 space cursor" :class="currentPage==1?'disabel':''" @click="prePage">上一页</p>
            <p class="font-size-12 font-color-264480 cursor" :class="currentPage==pages?'disabel':''" @click="nextPage">下一页</p>
          </div>
        </div>
      </div>

      <div class="page-content bg-white">
        <div v-if="reqParams.type=='resource'" class="menu-content-item-list">
          <div v-for="(cate, index) in topics" :key="index" class="menu-content-item-list-item" @click="selectCate(cate)">
            <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="currentTopic.name == cate.code?'sel':''">
              <p class="font-size-14">#{{ cate.name }}</p>
              <p class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
            </div>
          </div>
        </div>
        <div v-else class="menu-content-item-list">
          <div v-for="(cate, index) in topics" :key="index" class="menu-content-item-list-item" @click="selectCate(cate)">
            <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="currentTopic.name == cate.id?'sel':''">
              <p class="font-size-14">#{{ cate.topicName }}</p>
              <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="page-footer flex-center bg-white">
        <p class="bg-282B80 font-color-white flex-center font-size-14 radius-clip-5 btn cursor" @click="confirm">确定</p>
        <p class="bg-F3F4F9 font-color-264480 flex-center font-size-14 radius-clip-5 btn cursor" @click="closeView">关闭</p>
      </div>
    </div>
  </div>
</template>

<script>

import api from '../../../../../api/collections.js'

export default {
  data() {
    return {
      showView: false,
      topicTopSelIndex: 0,
      personLetters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      personTopSelIndex: 0,
      reqParams: { type: 'collection', data: { type: 0, size: 50, current: 1 }},
      currentPage: 1,
      total: 0,
      range: { start: 0, end: 0 },

      topics: [],

      currentTopic: {
        data: '',
        name: ''
      },
      pages: 0
    }
  },
  destroyed() {
    console.log('销毁')
  },
  methods: {
    show(data, searchType) {
      this.reqParams.type = searchType || 'collection'
      this.total = 0
      this.currentPage = 1
      this.range.start = 0
      this.range.end = 0
      this.pages = 0
      for (const key in data) {
        if (key === 'current' || key === 'size' || key === 'sortType') {
          continue
        } else {
          this.reqParams.data[key] = data[key]
        }
      }
      this.request()
      this.showView = true
    },
    request() {
      const that = this
      this.reqParams.data.current = this.currentPage
      this.reqParams.data.tenantId = this.$store.getters.tenantId 
      api.topicPage(this.reqParams).then(r => {
        that.total = r.data.total
        that.topics = r.data.records
        that.range.end = (that.currentPage - 1) * 50 + that.topics.length
        that.range.start = (that.currentPage - 1) * 50 + 1
        that.pages = r.data.pages
      })
    },
    prePage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
        this.request()
      }
    },
    nextPage() {
      if (this.currentPage < this.pages) {
        this.currentPage += 1
        this.request()
      }
    },
    topicMenuSelect(v) {
      this.topicTopSelIndex = v.currentTarget.dataset.sel
      if (parseInt(this.topicTopSelIndex) === 1) {
        this.reqParams.data.type = 1
      } else {
        this.reqParams.data.type = 0
      }
      this.currentPage = 1
      this.request()
    },

    personMenuSelect(v) {
      this.personTopSelIndex = v.currentTarget.dataset.sel
    },
    selectCate(v) {
      if (this.reqParams.type === 'resource') {
        if (this.currentTopic.name !== v.code) {
          this.currentTopic.name = v.code
          this.currentTopic.data = v
        }
      } else {
        if (this.currentTopic.name !== v.id) {
          this.currentTopic.name = v.id
          this.currentTopic.data = v
        }
      }
    },
    confirm() {
      this.total = 0
      this.range.start = 0
      this.range.end = 0
      this.showView = false
      if (this.reqParams.type === 'resource') {
        this.$emit('select', { params: { tibetanTube: this.currentTopic.data.code }, display: this.currentTopic.data.name, type: 'tibetanTube' })
      } else {
        this.$emit('select', { params: { specialSubject: this.currentTopic.name }, display: this.currentTopic.data.topicName, type: 'specialSubject' })
      }
    },
    closeView() {
      this.total = 0
      this.range.start = 0
      this.range.end = 0
      this.currentTopic = {
        data: '',
        name: ''
      }
      this.showView = false
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
  .page-alert {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }

  .page-body {
    width: 500px;
  }

  .page-header {
    padding: 0 20px;
    height: 60px;
  }

  .page-options {
    border-bottom: 1px solid #eee;
  }

  .page-options-region-topic {
    height: 40px;
    padding: 0 20px;
  }

  .page-options-selection>div {
    padding: 0 6px;
    width: 40px;
    height: 40px;
  }

   .page-options-selection .line {
     height: 3px;
     width: 40px;
     bottom: 0;
   }

  .page-options-region-date{
    height: 40px;
    justify-content: end;
    padding: 0 16px;
  }

  .space {
    margin-right: 8px;
  }

  .page-content {
    height: 380px;
    overflow: scroll;
  }

  .page-footer {
    height: 60px;
  }

  .page-footer .btn {
    width: 100px;
    height: 30px;
    font-weight: 400;
    margin-right: 10px;
  }

  .page-footer .btn:last-child {
    margin: 0;
  }

  .page-options-region-person-pages {
    height: 24px;
    justify-content: end;
    padding: 0 20px;
  }

  .page-options-region-person-items {
    height: 24px;
    padding: 0 20px;
    margin-bottom: 10px;
  }

  .page-options-region-person-items .item {
    padding: 0 4px;
  }

  .page-options-region-person-items .item .p-line {
    left: 0;
    right: 0;
    bottom: -10px;
    height: 3px;
  }

  .menu-content-item-list-item-hg {
    height: 30px;
    padding: 0 10px;
  }

  .menu-content-item-list {
    padding: 10px;
  }
  .cate-sel-close {
    width: 30px;
    height: 30px;
  }

  .disabel {
    color: #999;
    cursor: not-allowed;
  }
  .sel {
   background-color: rgba(147, 150, 156, 0.4);
  }

  .sel p {
    color: #fff;
  }

</style>
